import { Injectable, inject } from '@angular/core';
import { BehaviorSubject, catchError, throwError } from 'rxjs';
import { TranslateService } from '@ngx-translate/core';
import { AppService } from '@src/api';
import { AlertService } from '@src/core/services';

import { AppConfigType } from './types';

@Injectable({
  providedIn: 'root',
})
export class AppConfigService {
  private readonly appService = inject(AppService);
  private readonly alertService = inject(AlertService);
  private readonly translateService = inject(TranslateService);

  readonly data$ = new BehaviorSubject<AppConfigType | null | undefined>(undefined);

  loadData(): void {
    this.appService
      .getBrandSettings()
      .pipe(
        catchError(() => {
          this.clearData();

          this.alertService.error(
            this.translateService.instant('components.appConfigService.alerts.errors.getBrandSettings'),
          );

          return throwError(() => new Error('Ошибка при получении конфигурации приложения'));
        }),
      )
      .subscribe(data => {
        this.data$.next(data);
      });
  }

  clearData() {
    this.data$.next(null);
  }

  getDocument(name: string) {
    return this.appService.getBrandDocument(name).pipe(
      catchError(() => {
        this.alertService.error(
          this.translateService.instant('components.appConfigService.alerts.errors.getBrandDocument'),
        );

        return throwError(() => new Error('Ошибка при получении файла конфигурации'));
      }),
    );
  }
}
